<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t("film.makers.list.page.title") }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t("film.makers.list.page.subtitle")
        }}</span>
      </div>
      <v-spacer></v-spacer>
      <NewFilmMakerDialog @created="getFilmMakers()"></NewFilmMakerDialog>
    </v-card-title>
    <v-card flat>
      <v-layout row wrap class="pa-3">
        <v-flex xs12 sm4 md4>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('film.makers.list.page.search.placeholder')"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-card-text v-if="filmMakers">
        <v-data-table
          :headers="table_headers"
          :items="filmMakers.data"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="total"
          :rowsPerPageItems="rowsPerPageItems"
        >
          <template v-slot:items="props">
            <tr
              :style="{ cursor: 'pointer' }"
              @click="$router.push({
                name: 'film.maker.profile',
                params: {
                    filmMakerId: props.item.id,
                },
              })"
            >
              <td class="text-xs-left subheading">{{ props.item.id }}</td>
              <td class="text-xs-left pa-1">
                <v-avatar size="50" color="red">
                  <img :src="props.item.profile_url" alt="alt" />
                </v-avatar>
              </td>
              <td class="text-xs-left">{{ props.item.name[currentLocale] }}</td>
              <td class="text-xs-left">
                <v-chip
                  class="secondary secondary--text font-weight-medium"
                  small
                  outline
                >
                  {{ DEFINES.SCREENER_STATUS[props.item.published] }}
                </v-chip>
              </td>
              <td class="text-xs-left">
                {{ DEFINES.FILMMAKER.TYPE[props.item.type] }}
              </td>
              <td class="text-xs-left">{{ props.item.created_at }}</td>
              <td class="text-xs-center">
                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    :to="{
                      name: 'film.maker.profile',
                      params: {
                        filmMakerId: props.item.id,
                      },
                    }"
                    icon
                    small
                    dark
                  >
                    <v-icon color="secondary"
                      >$vuetify.icons.rms_visibility</v-icon
                    >
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{ $t("rms.tooltip.view") }}
                  </span>
                </v-tooltip>
                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="deleteConfirmation(props.item.id)"
                  >
                    <v-icon color="secondary">$vuetify.icons.rms_delete</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{ $t("rms.tooltip.delete") }}
                  </span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ConfirmationDialog
      :dialog="confirmation"
      @confirm="remove()"
      @cancel="confirmation = false"
    />
  </v-card>
</template>
<script>
import i18n from "@/i18n";
import NewFilmMakerDialog from "@/components/filmMakers/NewFilmMakerDialog.vue";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import DEFINES from "@/defines";
export default {
  name: "FilmMakerList",
  components: {
    NewFilmMakerDialog,
    ConfirmationDialog,
  },
  data() {
    return {
      search: "",
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      filters: {},
      total: 0,
      table_headers: [
        {
          text: i18n.t("film.makers.list.table.header.id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: i18n.t("film.makers.list.table.header.picture"),
          align: "left",
          sortable: false,
          value: "image",
        },
        {
          text: i18n.t("film.makers.list.table.header.name"),
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: i18n.t("film.makers.list.table.header.published"),
          align: "left",
          sortable: false,
          value: "published",
        },
        {
          text: i18n.t("film.makers.list.table.header.type"),
          align: "left",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("film.makers.list.table.header.created_at"),
          align: "left",
          sortable: false,
          value: "created_at",
        },
        {
          text: i18n.t("film.makers.list.table.header.actions"),
          align: "left",
          sortable: false,
        },
      ],
      filmMakers: [],
      loading: false,
      confirmation: false,
    };
  },
  created() {
    this.bootstrap();
  },
  computed:{
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    /**
     * Fetch all dependency of a film in parent
     */
    async bootstrap() {
      this.isLoading = true;
      await this.getFilmMakers();
      this.isLoading = false;
    },

    async getFilmMakers() {
      return this.$store
        .dispatch("filmMaker/list", {
          search: this.search,
        })
        .then((response) => {
          this.filmMakers = response;
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: this.DEFINES.SNACKBAR_ERROR_COLOR,
          });
        });
    },

    applySearch() {
      if (this.search.length) this.getFilmMakers();
    },
    clearSearch() {
      this.search = "";
      this.getFilmMakers();
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),

    deleteConfirmation(filmMakerId) {
      this.deleteFilmMakerId = filmMakerId;
      this.confirmation = true;
    },

    async remove() {
      await this.$store
        .dispatch("filmMaker/delete", {
          id: this.deleteFilmMakerId,
        })
        .then((res) => {
          this.getFilmMakers();
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: this.DEFINES.SNACKBAR_ERROR_COLOR,
          });
        })
        .finally(() => {
          this.confirmation = false;
          this.deleteFilmMakerId = null;
        });
    },
  },
};
</script>
